import YoutubeEmbed from '../YoutubeEmbed'

import ExceptionalROI from '../../Icons/realestateinvestor/exceptionalroi.svg'
import CoversionsAndResponseRate from '../../Icons/realestateinvestor/coversionsandresponserate.svg'
import IncreasedInvestment from '../../Icons/realestateinvestor/increasedinvestment.svg'
// import { useRouter } from 'next/router'

export default function WhyDirectMail() {
    // const router = useRouter()

    // const handleClick = () => {
    //     router.push('/products')
    // }

    const WhyDM = [
        {
            icon: ExceptionalROI,
            title: 'Exceptional ROI',
            // desc: 'With 84% of marketers confirming the highest ROI from direct mail, it’s the smart choice for real estate investors.',
            desc: 'With 84% of marketers confirming the highest ROI from direct mail, it’s the smart choice for real estate professionals.',
        },
        {
            icon: CoversionsAndResponseRate,
            title: 'Enhanced Conversion & Response Rates',
            desc: '85% of marketers agree that direct mail delivers superior conversion and response rates, crucial for your real estate deals.',
        },
        {
            icon: IncreasedInvestment,
            title: 'Increased Investment in Direct Mail',
            desc: 'A significant 82% of marketers, including those in real estate, are increasing their direct mail spend in 2024.',
        },
    ]
    return (
        <div
            id="whydirectmail"
            className="max-w-full w-[1200px] mx-auto md:mt-16 mt-[-3rem] mb-[4.6rem]">
            <div className="flex flex-col items-center text-center space-y-8 px-10 pt-5">
                <h3 className="font-bold text-3xl px-4 md:text-[44px] md:leading-[52px]">
                    <span>Why Choose Direct Mail for </span>
                    <br className="md:block hidden" />
                    <span className="olm-gradient-text">
                        Real Estate Investing
                    </span>
                    <span>?</span>
                </h3>
                <div className="md:px-12 w-full">
                    <YoutubeEmbed
                        cssClass={'rounded-xl w-full'}
                        url="https://www.youtube.com/watch?v=_aMzfNMYXBg"
                    />
                </div>
                <div className="flex flex-row md:flex-nowrap flex-wrap w-full md:space-x-4 md:space-y-0 space-y-4">
                    {WhyDM.map((why, i) => {
                        const Icon = why.icon
                        return (
                            <div
                                className="md:w-1/3 w-full bg-olm-gradient-t-to-b p-[1px] rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)]"
                                key={i}>
                                <div className="h-full flex flex-col items-center justify-center bg-white md:py-20 py-12 md:px-10 px-[40px] space-y-4 rounded-[20px]">
                                    <div className="my-5">
                                        <Icon />
                                    </div>
                                    <h3 className="font-bold text-[25px] leading-7">
                                        {why.title}
                                    </h3>
                                    <p className="md:text-xl text-lg text-[#444241]">
                                        {why.desc}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {/* <div className="w-96 max-w-full">
                    <GradientButton onClick={handleClick}>
                        Start With Direct Mail Today
                    </GradientButton>
                </div> */}
            </div>
        </div>
    )
}
